import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './components/DashboardLayout';
import FootfallView from './views/FootfallView';
import VenuesView from './views/venues/VenuesView';
import AddVenue from './views/venues/AddVenue';
import EditVenue from './views/venues/EditVenue';

import LocationsView from './views/locations/LocationsView';
import AddLocation from './views/locations/AddLocation';
import EditLocation from './views/locations/EditLocation';

import MusicView from './views/music/MusicView';
import AddMusic from './views/music/AddMusic';
import EditMusic from './views/music/EditMusic';

import DashboardOverview from './views/DashboardOverview';
import Login from './Login';
import { useAuth } from './AuthContext';


function App() {
    const { authenticated, loading } = useAuth();
    if (loading) {
      return <div>Checking authentication...</div>; // or a spinner
    }

  return (

      <Routes>
        <Route path="/" element={authenticated ? <Navigate to="/dashboard" /> : <Login />} />

      {/* Protected dashboard routes */}
          <Route path="/dashboard" element={authenticated ? <DashboardLayout /> : <Navigate to="/" />}>
          <Route index element={<Navigate to="overview" />} />
          <Route path="overview" element={<DashboardOverview />} />
          <Route path="footfall" element={<FootfallView />} />

          {/* Venues */}
          <Route path="venues" element={<VenuesView />} />
          <Route path="venues/add" element={<AddVenue />} />
          <Route path="venues/edit/:id" element={<EditVenue />} />

          {/* Locations */}
          <Route path="locations" element={<LocationsView />} />
          <Route path="locations/add" element={<AddLocation />} />
          <Route path="locations/edit/:id" element={<EditLocation />} />

          {/* Music */}
          <Route path="music" element={<MusicView />} />
          <Route path="music/add" element={<AddMusic />} />
          <Route path="music/edit/:id" element={<EditMusic />} />
        </Route>
        
        {/* Redirect /overview to /dashboard/overview for convenience */}
        <Route path="/overview" element={<Navigate to="/dashboard/overview" />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>
  );
}

export default App;

